export default __webpack_public_path__ + "static/media/work_anytime.a983ddf8.jpg";